import React from "react";

const Fallback = () => {
  return <div>Loading...</div>;
};

export default Fallback;
